export default __webpack_public_path__ + "static/media/title-deco-right.1688bf24.webp";